import { strCode } from "../../../../../consts";

export const metricsConfig = {
  updated: {
    id: "updated",
    name: strCode.UPDATED_LABEL,
    color: "#2BBA99"
  },
  inProgress: {
    id: "inProgress",
    name: strCode.IN_PROGRESS_LABEL,
    color: "#306252"
  },
  queued: {
    id: "queued",
    name: strCode.QUEUED_LABEL,
    color: "#94DEC9"
  },
  canceled: {
    id: "canceled",
    name: strCode.CANCELED_LABEL,
    color: "#FBBDC3"
  },
  removed: {
    id: "removed",
    name: strCode.REMOVED_LABEL,
    color: "#F78C96"
  },
  rejected: {
    id: "rejected",
    name: strCode.REJECTED_LABEL,
    color: "#C34954"
  },
  failed: {
    id: "failed",
    name: strCode.FAILED_LABEL,
    color: "#F45B69"
  },
  neverAttempted: {
    id: "neverAttempted",
    name: strCode.NEVER_ATTEMPTED_LABEL,
    color: "#99969C"
  }
};
